import CustomChip from '../../../components/CustomChip';
import { useLanguage } from '../../../contexts/language';
import { BADGE_CLASSNAMES } from '../../../utils/styles';
import { ContractBadgeStatus } from './types';

export interface ContractBadgeProps {
  status: ContractBadgeStatus;
  small?: boolean;
}

const ContractBadge = ({ status, small }: ContractBadgeProps) => {
  const { t } = useLanguage();
  return (
    <CustomChip
      label={t(`content.${status}`)}
      small={small}
      className={
        status === ContractBadgeStatus.Expired
          ? BADGE_CLASSNAMES.RED
          : status === ContractBadgeStatus.Uncompliant
            ? BADGE_CLASSNAMES.YELLOW
            : BADGE_CLASSNAMES.GREEN
      }
    />
  );
};

export default ContractBadge;
